// Analytics rollup landing page for /admin. Single fetch to
// /api/admin/analytics/; renders a grid of StatCards + a few top-N lists.

import React, { useEffect, useState } from 'react';
import { getAnalytics } from '../../services/adminService';
import StatCard, { StatRow } from '../common/StatCard';
import DataTable from '../common/DataTable';

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    getAnalytics()
      .then(d => { if (alive) setData(d); })
      .catch(e => { if (alive) setError(e?.response?.data?.detail || e.message); });
    return () => { alive = false; };
  }, []);

  if (error) return <><div className="portal-content-header"><h1>Dashboard</h1></div><div className="portal-error">{error}</div></>;
  if (!data) return <><div className="portal-content-header"><h1>Dashboard</h1></div><div className="portal-empty">Loading…</div></>;

  const { users: u, tasks: t, coupons: c, flyers: f, stores: s, push: p } = data;

  return (
    <>
      <div className="portal-content-header">
        <h1>Dashboard</h1>
        <span style={{ fontSize: 'var(--tudu-fs-xs)', color: 'var(--tudu-text-lo)' }}>
          Updated {new Date(data.generated_at).toLocaleTimeString()}
        </span>
      </div>

      <h3 className="portal-section-label">Users</h3>
      <StatRow>
        <StatCard label="Total users" value={u.total} />
        <StatCard label="Active (30d)" value={u.active_30d} hint={`${Math.round(u.active_30d / Math.max(u.total, 1) * 100)}% of total`} />
        <StatCard label="New (7d)" value={u.new_7d} />
        <StatCard label="Customers" value={u.by_role.customer || 0} />
        <StatCard label="Merchants" value={u.by_role.merchant || 0} />
        <StatCard label="Admins" value={u.by_role.admin || 0} />
      </StatRow>

      <h3 className="portal-section-label">Tasks</h3>
      <StatRow>
        <StatCard label="Total tasks" value={t.total} />
        <StatCard label="Created (7d)" value={t.created_7d} />
        <StatCard label="Completion rate" value={`${t.completion_rate}%`} />
      </StatRow>

      <h3 className="portal-section-label">Coupons & flyers</h3>
      <StatRow>
        <StatCard label="Active coupons" value={c.total_active} />
        <StatCard label="Total claims" value={c.claims_total} />
        <StatCard label="Claims (7d)" value={c.claims_7d} />
        <StatCard label="Flyers" value={`${f.active} / ${f.total}`} hint="active / total" />
        <StatCard label="Parsed deals" value={f.deals_total} />
      </StatRow>

      <h3 className="portal-section-label">Stores & push</h3>
      <StatRow>
        <StatCard label="Stores" value={s.total} hint={`${s.with_owner} with owner`} />
        <StatCard label="Free tier" value={s.by_subscription_tier.free || 0} />
        <StatCard label="Basic tier" value={s.by_subscription_tier.basic || 0} />
        <StatCard label="Pro tier" value={s.by_subscription_tier.pro || 0} />
        <StatCard label="Push tokens" value={p.tokens_total} hint={`Android ${p.by_platform.android || 0} · iOS ${p.by_platform.ios || 0}`} />
      </StatRow>

      <h3 className="portal-section-label">Top stores by coupon claims</h3>
      <DataTable
        columns={[
          { key: 'store_name', label: 'Store' },
          { key: 'claims', label: 'Claims' },
        ]}
        rows={c.top_stores}
        emptyMessage="No coupon claims yet."
      />

      <h3 className="portal-section-label">Tasks by category</h3>
      <DataTable
        columns={[
          { key: 'category', label: 'Category' },
          { key: 'count', label: 'Tasks' },
        ]}
        rows={t.by_category}
        emptyMessage="No tasks yet."
      />
    </>
  );
}
